import * as React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ProductPage from "pages/product"
import ProductAddPage from "pages/product/add"
import ProductEditPage from "pages/product/editor"
import ProductVariantPage from "pages/product/variant"
import ProductPricePage from "pages/product/price"

import ProductOption from "pages/product_option"
import ProductOptionAddPage from "pages/product_option/add"
import OrderList from "pages/order/List"
import OrderDetail from "pages/order/Detail"
import OrderEdit from "pages/order/edit"
import Voucher from "pages/voucher/list"
import OrderPaymentList from "pages/order-payment/List"
import DebtList from "pages/debt/list"
import CustomerList from "pages/customer"
import Tags from "pages/tag"
import ProductCategory from "pages/category"
import WebsiteGeneralSetting from "pages/website_setting/General"
import WebsitePaymentSetting from "pages/website_setting/Payment"
import PrintSetting from "pages/setting/Print"
import OrderSetting from "pages/website_setting/Order"
import ProductOptionAddParentPage from "pages/product_option/add_parentoption"
import PointConfig from "pages/loyalty/Point"
import UserList from "pages/setting/User"
import WarehouseSettingPage from "pages/setting/Warehouse"
import InternalStatusSettingPage from "pages/setting/InternalStatus"
import InviteList from "pages/account/InviteList"
import ShopList from "pages/account/ShopList"
import AccountInfo from "pages/account/Info"
import SubscriptionPage from "pages/account/subscription"
import HomePageSetting from "pages/website_setting/home_page"
import ShippingFee from "pages/website_setting/Shippingfee"
import ScriptSetting from "pages/website_setting/Script"
import CommissionSetting from "pages/collaborator/CommissionSetting"
import Collaborators from "pages/collaborator/User"
import CollaboratorOrder from "pages/collaborator-user/order/List"
import CollaboratorDashboard from "pages/collaborator-user/Dashboard"
import CollaboratorProduct from "pages/collaborator-user/product"
import CollaboratorOrderDetail from "pages/collaborator-user/order/Detail"
import CollaboratorWithdraw from "pages/collaborator/Withdraw"
import WebsiteReport from "pages/report/website"
import Dashboard from "pages/report/dashboard"
import ShopReport from "pages/report/shop"
import ProductCollection from "pages/product_collection"
import PricingSettingPage from "pages/pricing/setting"
import PricingListPage from "pages/pricing/list"
import PricingEditPage from "pages/pricing/edit"
import ChatPage from "pages/chat"
import NotificationPage from "pages/notification"
import NotificationSettingsPage from "pages/notification/settings"
import SeoBrandProfilePage from "pages/seo_center/BrandProfile"
import SeoSocialSharePage from "pages/seo_center/SocialShare"
import SeoLandingListPage from "pages/seo_center/LandingList"
import SeoLandingEditorPage from "pages/seo_center/LandingEditor"
import SeoFeedCenterPage from "pages/seo_center/FeedCenter"
import { useAuth } from "contexts/auth"

//     { label: "Quản lý sản phẩm", value: "product.all" },
//     { label: "Quản lý đơn hàng", value: "order.all" },
//     { label: "Quản lý khách hàng", value: "customer.all" },
//     { label: "Quản lý công nợ", value: "debt.all" },
//     { label: "Quản lý voucher", value: "voucher.all" },
//     { label: "Cấu hình shop", value: "setting.all" },
// ]
const PageRoutes = () => {
  const { user } = useAuth();
  const [routes, setRoutes] = React.useState([]);
  var defaultPage = null;
  switch (user.work_space?.role) {

    case "ctv":
      defaultPage = <CollaboratorDashboard></CollaboratorDashboard>
      break;

    default:
      defaultPage = <Dashboard></Dashboard>
      break;
  }
  const allRouters = [
    { element: <Route path="/vouchers" element={<Voucher></Voucher>} />, permission: "product.all" },
    { element: <Route path="/product/add" element={<ProductAddPage></ProductAddPage>} />, permission: "product.all" },
    { element: <Route path="/product/info/:id" element={<ProductAddPage></ProductAddPage>} />, permission: "product.all" },
    { element: <Route path="/product/variant/:id" element={<ProductVariantPage></ProductVariantPage>} />, permission: "product.all" },
    { element: <Route path="/product/price/:id" element={<ProductPricePage></ProductPricePage>} />, permission: "product.all" },
    { element: <Route path="/product/edit/:id" element={<ProductEditPage></ProductEditPage>} />, permission: "product.all" },
    { element: <Route path="/products" element={<ProductPage></ProductPage>} />, permission: "product.all" },
    { element: <Route path="/product_option/" element={<ProductOption></ProductOption>} />, permission: "product.all" },
    { element: <Route path="/product_option/add" element={<ProductOptionAddPage></ProductOptionAddPage>} />, permission: "product.all" },
    { element: <Route path="/product_option/edit/:parentid/:id" element={<ProductOptionAddPage></ProductOptionAddPage>} />, permission: "product.all" },
    { element: <Route path="/product_option/add_parentoption" element={<ProductOptionAddParentPage></ProductOptionAddParentPage>} />, permission: "product.all" },
    { element: <Route path="/product_option/edit_parentoption/:id" element={<ProductOptionAddParentPage></ProductOptionAddParentPage>} />, permission: "product.all" },
    { element: <Route path="/product_tag/" element={<Tags></Tags>} />, permission: "product.all" },
    { element: <Route path="/product_category/" element={<ProductCategory></ProductCategory>} />, permission: "product.all" },
    { element: <Route path="/product_collection/" element={<ProductCollection></ProductCollection>} />, permission: "product.all" },
    { element: <Route path="/customers" element={<CustomerList></CustomerList>} />, permission: "customer.all" },
    { element: <Route path="/chats" element={<ChatPage></ChatPage>} />, permission: "customer.all" },
    { element: <Route path="/notifications" element={<NotificationPage></NotificationPage>} />, permission: "" },
    { element: <Route path="/notifications/settings" element={<NotificationSettingsPage></NotificationSettingsPage>} />, permission: "" },
    { element: <Route path="/payment-confirm" element={<OrderPaymentList></OrderPaymentList>} />, permission: "" },
    { element: <Route path="/debt" element={<DebtList></DebtList>} />, permission: "debt.all" },
    { element: <Route path="/orders" element={<OrderList></OrderList>} />, permission: "order.all" },
    { element: <Route path="/order/edit/:id" element={<OrderEdit></OrderEdit>} />, permission: "order.all" },
    { element: <Route path="/order/add/:id?" element={<OrderEdit></OrderEdit>} />, permission: "order.all" },
    { element: <Route path="/order/:id" element={<OrderDetail></OrderDetail>} />, permission: "order.all" },
    { element: <Route path="/website/setting/general/" element={<WebsiteGeneralSetting></WebsiteGeneralSetting>} />, permission: "" },
    { element: <Route path="/website/setting/homepage/" element={<HomePageSetting></HomePageSetting>} />, permission: "" },
    { element: <Route path="/website/setting/payment/" element={<WebsitePaymentSetting></WebsitePaymentSetting>} />, permission: "" },
    { element: <Route path="/website/setting/print/" element={<PrintSetting></PrintSetting>} />, permission: "" },
    { element: <Route path="/setting/print" element={<PrintSetting></PrintSetting>} />, permission: "setting.all" },
    { element: <Route path="/website/setting/order/" element={<OrderSetting></OrderSetting>} />, permission: "" },
    { element: <Route path="/website/setting/shippingfee" element={<ShippingFee></ShippingFee>} />, permission: "" },
    { element: <Route path="/website/setting/script" element={<ScriptSetting></ScriptSetting>} />, permission: "" },
    { element: <Route path="/seo-center/brand-profile" element={<SeoBrandProfilePage></SeoBrandProfilePage>} />, permission: "website.all" },
    { element: <Route path="/seo-center/social-share" element={<SeoSocialSharePage></SeoSocialSharePage>} />, permission: "website.all" },
    { element: <Route path="/seo-center/landing" element={<SeoLandingListPage></SeoLandingListPage>} />, permission: "website.all" },
    { element: <Route path="/seo-center/landing/new" element={<SeoLandingEditorPage></SeoLandingEditorPage>} />, permission: "website.all" },
    { element: <Route path="/seo-center/landing/edit/:id" element={<SeoLandingEditorPage></SeoLandingEditorPage>} />, permission: "website.all" },
    { element: <Route path="/seo-center/feed" element={<SeoFeedCenterPage></SeoFeedCenterPage>} />, permission: "website.all" },
    { element: <Route path="/loyalty/setting/point/" element={<PointConfig></PointConfig>} />, permission: "setting.all" },
    { element: <Route path="/setting/user" element={<UserList></UserList>} />, permission: "setting.all" },
    { element: <Route path="/setting/warehouse" element={<WarehouseSettingPage></WarehouseSettingPage>} />, permission: "setting.all" },
    { element: <Route path="/setting/internal-status" element={<InternalStatusSettingPage></InternalStatusSettingPage>} />, permission: "setting.all" },
    { element: <Route path="/setting/pricing-tables" element={<PricingSettingPage></PricingSettingPage>} />, permission: "setting.all" },
    { element: <Route path="/pricing" element={<PricingListPage></PricingListPage>} />, permission: "setting.all" },
    { element: <Route path="/pricing/add" element={<PricingEditPage></PricingEditPage>} />, permission: "setting.all" },
    { element: <Route path="/pricing/edit/:id" element={<PricingEditPage></PricingEditPage>} />, permission: "setting.all" },
    { element: <Route path="/collaborator/commission" element={<CommissionSetting></CommissionSetting>} />, permission: "setting.all" },
    { element: <Route path="/collaborator/users" element={<Collaborators></Collaborators>} />, permission: "setting.all" },
    { element: <Route path="/collaborator/dashboard" element={<CollaboratorDashboard></CollaboratorDashboard>} />, role: "ctv" },
    { element: <Route path="/collaborator/order" element={<CollaboratorOrder></CollaboratorOrder>} />, role: "ctv" },
    { element: <Route path="/collaborator/order/:id" element={<CollaboratorOrderDetail></CollaboratorOrderDetail>} />, role: "ctv" },
    { element: <Route path="/collaborator/product" element={<CollaboratorProduct></CollaboratorProduct>} />, role: "ctv" },
    { element: <Route path="/collaborator/withdraw/:id" element={<CollaboratorWithdraw></CollaboratorWithdraw>} />, permission: "setting.all" },
    { element: <Route path="/website/report/" element={<WebsiteReport></WebsiteReport>} />, permission: "" },
    { element: <Route path="/report/shop" element={<ShopReport></ShopReport>} />, permission: "" },
    { element: <Route path="/dashboard" element={<Dashboard></Dashboard>} />, permission: "" },
    { element: <Route path="/" element={defaultPage} />, permission: "" },
  ]









  React.useEffect(() => {

    var wp = user.work_space;
    var permissions = wp.permissions ?? [];

    var items = [...allRouters];
    if (!["admin", "owner"].includes(wp.role)) {

      items = items.filter(menu => {
        //ko cần quyền
        if (!menu.permission) {
          return true;
        }
        //lọc menu
        if (permissions.includes(menu.permission)) {
          return true;
        }
        if (wp.role == menu.role) {
          return true;
        }
        return false;
      })

    }
    setRoutes(items);
  }, [user])





















  return (
    <Routes>

      {routes.map(x => {

        var element = x?.element;
        return element;

      })}
      <Route path="/" element={<OrderList></OrderList>} />
      <Route path="/account/invitelist" element={<InviteList></InviteList>} />
      <Route path="/account/shoplist" element={<ShopList></ShopList>} />,
      <Route path="/account/info" element={<AccountInfo></AccountInfo>} />
      <Route path="/account/subscription" element={<SubscriptionPage></SubscriptionPage>} />
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/register" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default React.memo(PageRoutes);
